import { Box, HStack, Link, Text, chakra } from "@chakra-ui/react";
import { AlertTriangle, ArrowUpRight } from "lucide-react";

const ANNOUNCEMENT_URL =
  "https://x.com/OmnityNetwork/status/2092428611471241492";
const SUNSET_DATE = "September 25, 2026";

const AlertTriangleIcon = chakra(AlertTriangle);
const ArrowUpRightIcon = chakra(ArrowUpRight);

export default function SunsetBanner() {
  return (
    <Box
      as="aside"
      role="alert"
      w="100%"
      px={{ base: 4, md: 16 }}
      py={{ base: 2, md: 3 }}
      bg="linear-gradient(rgba(245, 158, 11, 0.13), rgba(245, 158, 11, 0.13)), rgba(4, 8, 26, 0.92)"
      backdropFilter="blur(12px)"
      borderBottom="1px solid"
      borderColor="rgba(245, 158, 11, 0.32)"
    >
      <HStack
        gap={{ base: 2, md: 3 }}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
      >
        <HStack gap={2} alignItems="flex-start">
          <AlertTriangleIcon
            size={18}
            color="#FBBF24"
            flexShrink={0}
            pos="relative"
            top="2px"
          />
          <Text
            fontSize={{ base: 13, md: 15 }}
            color="rgba(255, 255, 255, 0.88)"
            textAlign={{ base: "left", md: "center" }}
          >
            <chakra.span fontWeight={600} color="#FCD34D">
              Omnity Hub is shutting down.
            </chakra.span>{" "}
            Please withdraw all your assets before {SUNSET_DATE}.
          </Text>
        </HStack>
        <Link
          href={ANNOUNCEMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
          color="#FCD34D"
          fontSize={{ base: 13, md: 15 }}
          fontWeight={600}
          textDecoration="underline"
          textUnderlineOffset="3px"
          textDecorationColor="rgba(252, 211, 77, 0.45)"
          _hover={{ color: "#FDE68A", textDecorationColor: "#FDE68A" }}
        >
          <HStack as="span" display="inline-flex" gap={1} alignItems="center">
            <chakra.span>Read the announcement</chakra.span>
            <ArrowUpRightIcon size={14} pos="relative" top="1px" />
          </HStack>
        </Link>
      </HStack>
    </Box>
  );
}
